module.exports = __webpack_public_path__ + "img/service-partner-header-img.e020c3f2.jpg";